import { MOBILE_BREAKPOINT } from "@/lib/device-format";

/**
 * The `target` of a link to another page of the app.
 *
 * On a desktop a company or a conversation opens in a tab of its own, so the
 * page the user works in stays where it was. On a phone there are no tabs to
 * come back from, and in the app installed on iOS — an iPad or a phone in
 * landscape included — a new tab is Safari, where the user is signed out:
 * there it opens in place, and back returns. A desktop install shares the
 * browser's session, so its new tab stays signed in and keeps the tab.
 *
 * Read at render, not subscribed: table cell renderers call it outside a
 * component. A resize across the breakpoint remounts the tree anyway.
 */
export function internalLinkTarget(): "_blank" | undefined {
  const isMobile = window.matchMedia(
    `(max-width: ${MOBILE_BREAKPOINT - 1}px)`
  ).matches;
  // `standalone` is Safari's own flag, set only in an app added to the Home
  // Screen on iOS.
  const isInstalledOnIos =
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return isMobile || isInstalledOnIos ? undefined : "_blank";
}
